import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'stockholm-home-heart-svg-icon',
    templateUrl: 'stockholm-home-heart-svg-icon.component.html',
    standalone: false
})

export class StockholmHomeHeartSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
